module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-07-7c13bb0deab5bdf29bc70a603c1e6cfc.png";